import { CreditNotesStatusApiService } from '@api/api.service';
import { ReceiptStatusService } from '../base';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CreditNoteStatusService extends ReceiptStatusService {
  constructor(api: CreditNotesStatusApiService) {
    super(api);
  }
}
